import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { getRequestId } from 'js/utils/getRequestId';

interface HitParams {
  /** URL to record the hit for */
  url: string;
  /** Actual referrer */
  referrer: string;
  /** Unsure what this means, possibly unused */
  quick_view?: string;
  request_id?: string;

  [key: string]: string | undefined;
}

export interface HitData {
  id: number;
  time: number;
  auvid: string;
  url: string;
  email_method?: string;
  email_tracking_token?: string;
}

/* This global value will have been set in _global.html.erb */
/* if it is true, we disable client side hit recording for this request */
declare const $disableClientRecordHit: boolean;

/**
 * Record a client-side hit. Normally used for logged-out loads that can't be recorded from the backend,
 * but also useful for recording "synthetic" pages (i.e. react-router)
 * @param data                         Data for the hit
 * @param allowFrontendNavigationHits  A flag to override the disabling by
 *                                     $disableClientRecordHit. Used for
 *                                     legitimate sources of frontend tracking,
 *                                     like in a react-router
 */
export async function recordHit(
  hitParams: HitParams,
  allowFrontendNavigationHits = false,
): Promise<HitData | null> {
  // if hits are disabled, don't record
  if ($disableClientRecordHit && !allowFrontendNavigationHits) {
    // Return a resolved promise with null if hits are disabled
    return Promise.resolve(null);
  }

  const url_params = new URLSearchParams();
  for (const key in hitParams) {
    const value = hitParams[key];

    if (value) {
      url_params.set(key, value);
    }
  }

  const requestId = getRequestId();
  if (requestId) {
    url_params.set('request_id', requestId);
  }

  const response = await fetchWithCsrf(`/record_hit?${url_params.toString()}`, {
    method: 'POST',
  });
  if (!response.ok) {
    return Promise.reject(response.statusText);
  } else {
    return response.json();
  }
}
